import React, { useContext } from 'react';
import { ProductContext } from '../contexts/ProductContext';
import Product from '../components/Product'
import Hero from '../components/Hero';

const Home = () => {
  const { products } = useContext(ProductContext);

  // const filteredProducts = products.filter(item=>{
  //   return item.category === "men's clothing" 
  //   || item.category === "women's clothing"
  // })
  // const filteredProducts1 = products.filter(item=>{
  // return item.category === "electronics" 
  // })
  // const filteredProducts2 = products.filter(item=>{
  //   return item.category === "jewelery" 
  // })

  return <div>
    <Hero />
    <section className='py-16 bg-[#FAF1E6]'>
      <div className='container mx-auto'>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-[30px] max-w-sm mx-auto md:max-w-none md:mx-0'>
          {
            products.map((product) => {
              return <Product product={product} key={product.id} />
            })}
        </div>
      </div>
    </section>
  </div>;
};

export default Home;
